import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  format() {
    const prefix = "+54 9 "
    let d = this.element.value.replace(/\D/g, "")

    // normalizo lo que la gente suele tipear
    if (d.startsWith("00")) d = d.slice(2)
    if (d.startsWith("549")) d = d.slice(3)
    else if (d.startsWith("54")) d = d.slice(2)
    if (d.startsWith("9")) d = d.slice(1)
    d = d.replace(/^(\d{2,5})15/, "$1") 

    d = d.slice(0, 12)

    let area = ""
    let local = d
    if (d.length > 7) {
      area = d.slice(0, d.length - 7)
      local = d.slice(-7)
    }

    this.element.value = (prefix + (area ? area + " " : "") + local).trimEnd()
  }
}
